import { render, staticRenderFns } from "./CustomSetting.vue?vue&type=template&id=30fffa04&scoped=true&"
import script from "./CustomSetting.vue?vue&type=script&lang=ts&"
export * from "./CustomSetting.vue?vue&type=script&lang=ts&"
import style0 from "./CustomSetting.vue?vue&type=style&index=0&id=30fffa04&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fffa04",
  null
  
)

export default component.exports